function renderEmailAdresses () {

    /*
     * Replaces masked email addresses
     * Scheme for addresses "[name (at) domain (punkt) de]"
     */

    let defaults = {
        selectors: {
            email: '.epost, .is-email, [href*="(at)"]',
        }
    }

        // Email adresses

    let getEmail = function(element) {

        const text = element.innerText;

        let email = {
            label: text,
            href: ""
        };

        if (typeof text !== "string" || text === "") {
            return email;
        }

        let href = element.getAttribute("href");

        if (! href) {
            href = email.label;
            email.label = "";
        }

            // Email address in brackets

        if (href.search(/\[.*\]/) !== -1) {

            let results = href.match(/(.*?) ?\[(.*)\]/);

            href = results[2] ? results[2] : href;
            email.label = results[1] ? results[1] : email.label;

        }

        // De-mask href

        href = href.replace(/ ?\(at\) ?/, "@");
        href = href.replace(/ ?\((punkt|dot)\) ?/, ".");

        email.href = "mailto:" + href;

        if (email.label === "") {
            email.label = href;
        }

        return email;

    }

    let elements = document.querySelectorAll(defaults.selectors.email);

    elements.forEach((element) => {

        let email = getEmail(element);

        element.innerText = email.label;

        if (element.title !== "") {
            email.href += "?subject=" + element.title;
        }

        console.log(email);

        if (email.href) {

            if (element.tagName !== "A") {

                const newNode = document.createElement('a');

                newNode.classList = element.classList;

                newNode.setAttribute("href", email.href);
                newNode.innerText = email.label;

                element.replaceWith(newNode);

            } else {

                element.setAttribute("href", email.href);
                element.innerText = email.label;

            }

        }

    });

}

function segmentEmailAdresses() {

    let addresses = document.querySelectorAll('a[href^="mailto:"]');

    addresses.forEach((address) => {

        let label = address.innerHTML;

        if (! label.match(/@/)) {
            return;
        }

        let [name, domain] = label.split(/@/);

        // Add word breaks to chunks beginning with period and greater than 5 characters
        name = name.replace(/\.(\w{5,})/g, ".<wbr>$1");

        // Remove word breaks to chunks at start smaller than 5 characters
        name = name.replace(/^([^>]*>)?(\w{1,4})\.<wbr>/g, "$1$2.");

        address.innerHTML = `${name}@<wbr>${domain}`;

    });

}

export {
    renderEmailAdresses,
    segmentEmailAdresses,
};
